import { render, staticRenderFns } from "./adminemail.vue?vue&type=template&id=d13420b0&scoped=true&"
import script from "./adminemail.vue?vue&type=script&lang=js&"
export * from "./adminemail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13420b0",
  null
  
)

export default component.exports